// extracted by mini-css-extract-plugin
var _1 = "ChapterCompleteModal__confettiCanvas--hZ45o";
var _2 = "ChapterCompleteModal__illustration--qipAt";
var _3 = "ChapterCompleteModal__illustrationWrap--ZGWVo";
export { _1 as "confettiCanvas", _2 as "illustration", _3 as "illustrationWrap" }
